Object.defineProperty(exports, "__esModule", {
  value: true
});

var _maxBy2 = require("lodash/maxBy");

var _maxBy3 = _interopRequireDefault(_maxBy2);

var _sumBy2 = require("lodash/sumBy");

var _sumBy3 = _interopRequireDefault(_sumBy2);

var _defaults2 = require("lodash/defaults");

var _defaults3 = _interopRequireDefault(_defaults2);

var _isEmpty2 = require("lodash/isEmpty");

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _merge2 = require("lodash/merge");

var _merge3 = _interopRequireDefault(_merge2);

var _jsxFileName = "src/victory-legend/victory-legend.js";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = require("../victory-util/prop-types");

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _style = require("../victory-util/style");

var _style2 = _interopRequireDefault(_style);

var _textsize = require("../victory-util/textsize");

var _textsize2 = _interopRequireDefault(_textsize);

var _helpers = require("../victory-util/helpers");

var _helpers2 = _interopRequireDefault(_helpers);

var _victoryLabel = require("../victory-label/victory-label");

var _victoryLabel2 = _interopRequireDefault(_victoryLabel);

var _victoryContainer = require("../victory-container/victory-container");

var _victoryContainer2 = _interopRequireDefault(_victoryContainer);

var _victoryTheme = require("../victory-theme/victory-theme");

var _victoryTheme2 = _interopRequireDefault(_victoryTheme);

var _point = require("../victory-primitives/point");

var _point2 = _interopRequireDefault(_point);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var defaultLegendData = [{
  name: "Series 1"
}, {
  name: "Series 2"
}];

var VictoryLegend = function (_React$Component) {
  _inherits(VictoryLegend, _React$Component);

  function VictoryLegend() {
    _classCallCheck(this, VictoryLegend);

    return _possibleConstructorReturn(this, (VictoryLegend.__proto__ || Object.getPrototypeOf(VictoryLegend)).apply(this, arguments));
  }

  _createClass(VictoryLegend, [{
    key: "calculateLegendHeight",
    value: function calculateLegendHeight(textSizes, padding, isHorizontal) {
      var _props = this.props,
          gutter = _props.gutter,
          itemsPerRow = _props.itemsPerRow;
      var itemCount = textSizes.length;
      var rowCount = itemsPerRow ? Math.ceil(itemCount / itemsPerRow) : 1;
      var contentHeight = isHorizontal ? (0, _maxBy3.default)(textSizes, "height").height * rowCount + gutter * (rowCount - 1) : ((0, _sumBy3.default)(textSizes, "height") + gutter * (itemCount - 1)) / rowCount;
      return padding.top + contentHeight + padding.bottom;
    }
  }, {
    key: "calculateLegendWidth",
    value: function calculateLegendWidth(itemCount, padding, isHorizontal, maxTextWidth) {
      var _props2 = this.props,
          gutter = _props2.gutter,
          itemsPerRow = _props2.itemsPerRow,
          symbolSpacer = _props2.symbolSpacer;
      var rowCount = itemsPerRow ? Math.ceil(itemCount / itemsPerRow) : 1;
      var rowItemCount = itemsPerRow || itemCount;
      var contentWidth = void 0;

      if (isHorizontal) {
        var gutterWidth = gutter * rowItemCount;
        var symbolWidth = symbolSpacer * 3 * rowItemCount;
        var textWidth = maxTextWidth * rowItemCount;
        contentWidth = symbolWidth + textWidth + gutterWidth;
      } else {
        contentWidth = (maxTextWidth + symbolSpacer * 2 + gutter) * rowCount;
      }

      return padding.left + contentWidth + padding.right;
    }
  }, {
    key: "getColorScale",
    value: function getColorScale(theme) {
      var colorScaleOptions = this.props.colorScale || theme.colorScale;

      if (typeof colorScaleOptions === "string") {
        colorScaleOptions = _style2.default.getColorScale(colorScaleOptions);
      }

      return !(0, _isEmpty3.default)(theme) ? colorScaleOptions || theme.colorScale : colorScaleOptions || [];
    }
  }, {
    key: "getCalculatedProps",
    value: function getCalculatedProps() {
      var _this2 = this;

      var role = this.constructor.role;
      var _props3 = this.props,
          data = _props3.data,
          orientation = _props3.orientation,
          theme = _props3.theme;
      var legendTheme = theme && theme[role] ? theme[role] : {};
      var parentStyles = this.getStyles({}, legendTheme, "parent");
      var colorScale = this.getColorScale(legendTheme);
      var isHorizontal = orientation === "horizontal";
      var symbolStyles = [];
      var labelStyles = [];
      var _props4 = this.props,
          height = _props4.height,
          padding = _props4.padding,
          width = _props4.width;
      var maxTextWidth = 0;
      padding = _helpers2.default.getPadding({
        padding: padding || theme.padding
      });
      height = _helpers2.default.evaluateProp(height || theme.height, data);
      width = _helpers2.default.evaluateProp(width || theme.width, data);
      var textSizes = data.map(function (datum, i) {
        var labelStyle = _this2.getStyles(datum, legendTheme, "labels");

        var textSize = _textsize2.default.approximateTextSize(datum.name, labelStyle);

        maxTextWidth = textSize.width > maxTextWidth ? textSize.width : maxTextWidth;
        symbolStyles[i] = _this2.getStyles(datum, legendTheme, "symbol", colorScale[i]);
        labelStyles[i] = labelStyle;
        return textSize;
      });

      if (!height) {
        height = this.calculateLegendHeight(textSizes, padding, isHorizontal);
      }

      if (!width) {
        width = this.calculateLegendWidth(textSizes.length, padding, isHorizontal, maxTextWidth);
      }

      return _extends({}, this.props, {
        isHorizontal: isHorizontal,
        height: height,
        labelStyles: labelStyles,
        maxTextWidth: maxTextWidth,
        padding: padding,
        parentStyles: parentStyles,
        symbolStyles: symbolStyles,
        width: width
      });
    }
  }, {
    key: "getStyles",
    value: function getStyles(datum, theme, key, color) {
      var style = this.props.style;
      var styleKey = key === "symbol" ? "data" : key;
      var colorScaleStyle = color ? {
        fill: color
      } : {};
      var styles = (0, _merge3.default)({}, theme.style[styleKey], colorScaleStyle, style[styleKey], datum[key]);
      return _helpers2.default.evaluateStyle(styles, datum);
    }
  }, {
    key: "getSymbolSize",
    value: function getSymbolSize(datum, fontSize) {
      return datum.symbol && datum.symbol.size ? datum.symbol.size : fontSize / 2.5;
    }
  }, {
    key: "getSymbolProps",
    value: function getSymbolProps(datum, props, i) {
      var dataComponent = props.dataComponent,
          gutter = props.gutter,
          isHorizontal = props.isHorizontal,
          itemsPerRow = props.itemsPerRow,
          labelStyles = props.labelStyles,
          maxTextWidth = props.maxTextWidth,
          padding = props.padding,
          symbolSpacer = props.symbolSpacer,
          symbolStyles = props.symbolStyles;
      var fontSize = labelStyles[i].fontSize;
      var symbolShift = fontSize / 2;
      var style = symbolStyles[i];
      var rowHeight = fontSize + gutter;
      var itemIndex = i;
      var rowSpacer = 0;
      var rowIndex = 0;

      if (itemsPerRow) {
        rowIndex = Math.floor(i / itemsPerRow);
        rowSpacer = rowHeight * rowIndex;
        itemIndex = i % itemsPerRow;
      }

      var symbolCoords = isHorizontal ? {
        x: padding.left + symbolShift + (fontSize + symbolSpacer + maxTextWidth + gutter) * itemIndex,
        y: padding.top + symbolShift + rowSpacer
      } : {
        x: padding.left + symbolShift + (rowHeight + maxTextWidth) * rowIndex,
        y: padding.top + symbolShift + rowHeight * itemIndex
      };
      return (0, _defaults3.default)({}, dataComponent.props, _extends({
        key: "symbol-" + i,
        style: style,
        size: this.getSymbolSize(datum, fontSize),
        symbol: style.type
      }, symbolCoords));
    }
  }, {
    key: "getLabelProps",
    value: function getLabelProps(datum, props, i) {
      var gutter = props.gutter,
          isHorizontal = props.isHorizontal,
          itemsPerRow = props.itemsPerRow,
          labelComponent = props.labelComponent,
          labelStyles = props.labelStyles,
          maxTextWidth = props.maxTextWidth,
          padding = props.padding,
          symbolSpacer = props.symbolSpacer;
      var style = labelStyles[i];
      var fontSize = style.fontSize;
      var symbolShift = fontSize / 2;
      var rowHeight = fontSize + gutter;
      var symbolWidth = fontSize + symbolSpacer;
      var itemIndex = i;
      var rowSpacer = 0;
      var rowIndex = 0;

      if (itemsPerRow) {
        rowIndex = Math.floor(i / itemsPerRow);
        rowSpacer = rowHeight * rowIndex;
        itemIndex = i % itemsPerRow;
      }

      var labelCoords = isHorizontal ? {
        x: padding.left + symbolWidth * (itemIndex + 1) + (maxTextWidth + gutter) * itemIndex,
        y: padding.top + symbolShift + rowSpacer
      } : {
        x: padding.left + symbolWidth + (rowHeight + maxTextWidth) * rowIndex,
        y: padding.top + symbolShift + rowHeight * itemIndex
      };
      return (0, _defaults3.default)({}, labelComponent.props, _extends({
        key: "label-" + i,
        style: style,
        text: datum.name
      }, labelCoords));
    }
  }, {
    key: "renderLegendItems",
    value: function renderLegendItems(props) {
      var _this3 = this;

      var data = props.data,
          dataComponent = props.dataComponent,
          labelComponent = props.labelComponent;
      var legendData = (0, _isEmpty3.default)(data) ? defaultLegendData : data;
      var dataComponents = legendData.map(function (datum, i) {
        return _react2.default.cloneElement(dataComponent, _this3.getSymbolProps(datum, props, i));
      });
      var labelComponents = legendData.map(function (datum, i) {
        return _react2.default.cloneElement(labelComponent, _this3.getLabelProps(datum, props, i));
      });
      return [].concat(_toConsumableArray(dataComponents), _toConsumableArray(labelComponents));
    }
  }, {
    key: "renderGroup",
    value: function renderGroup(props, children) {
      var groupComponent = props.groupComponent,
          height = props.height,
          parentStyles = props.parentStyles,
          standalone = props.standalone,
          width = props.width,
          x = props.x,
          y = props.y;
      var groupProps = {
        role: "presentation"
      };

      if (!standalone) {
        groupProps = _extends({
          height: height,
          width: width,
          transform: "translate(" + x + ", " + y + ")",
          style: parentStyles
        }, groupProps);
      }

      return _react2.default.cloneElement(groupComponent, groupProps, children);
    }
  }, {
    key: "renderContainer",
    value: function renderContainer(props, children) {
      var containerComponent = props.containerComponent,
          height = props.height,
          parentStyles = props.parentStyles,
          width = props.width;
      return _react2.default.cloneElement(containerComponent, {
        height: height,
        width: width,
        style: parentStyles
      }, children);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.getCalculatedProps();
      var group = this.renderGroup(props, this.renderLegendItems(props));
      return props.standalone ? this.renderContainer(props, group) : group;
    }
  }]);

  return VictoryLegend;
}(_react2.default.Component);

VictoryLegend.displayName = "VictoryLegend";
VictoryLegend.role = "legend";
VictoryLegend.propTypes = {
  colorScale: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.oneOf(["grayscale", "qualitative", "heatmap", "warm", "cool", "red", "green", "blue"])]),
  containerComponent: _propTypes2.default.element,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.object,
    symbol: _propTypes2.default.object
  })),
  dataComponent: _propTypes2.default.element,
  groupComponent: _propTypes2.default.element,
  gutter: _propTypes2.default.number,
  height: _propTypes2.default.oneOfType([_propTypes4.default.nonNegative, _propTypes2.default.func]),
  itemsPerRow: _propTypes2.default.number,
  labelComponent: _propTypes2.default.element,
  orientation: _propTypes2.default.oneOf(["horizontal", "vertical"]),
  padding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    top: _propTypes2.default.number,
    bottom: _propTypes2.default.number,
    left: _propTypes2.default.number,
    right: _propTypes2.default.number
  })]),
  standalone: _propTypes2.default.bool,
  style: _propTypes2.default.shape({
    data: _propTypes2.default.object,
    labels: _propTypes2.default.object,
    parent: _propTypes2.default.object
  }),
  symbolSpacer: _propTypes2.default.number,
  theme: _propTypes2.default.object,
  width: _propTypes2.default.oneOfType([_propTypes4.default.nonNegative, _propTypes2.default.func]),
  x: _propTypes2.default.number,
  y: _propTypes2.default.number
};
VictoryLegend.defaultProps = {
  data: defaultLegendData,
  containerComponent: _react2.default.createElement(_victoryContainer2.default, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76
    }
  }),
  dataComponent: _react2.default.createElement(_point2.default, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77
    }
  }),
  groupComponent: _react2.default.createElement("g", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78
    }
  }),
  gutter: 10,
  labelComponent: _react2.default.createElement(_victoryLabel2.default, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80
    }
  }),
  orientation: "vertical",
  standalone: true,
  style: {},
  symbolSpacer: 8,
  theme: _victoryTheme2.default.grayscale,
  x: 0,
  y: 0
};
exports.default = VictoryLegend;